<template>
    <div class="container">
        <entity-form :entity="entity" />
    </div>
</template>

<script>
import EntityForm from '@/components/Admin/PasswordForm.vue';
export default {
    name: "Entity",
    created(){
        this.fetchEntity();
    },
    components: {
        EntityForm
    },
    data: () => ({
        entity: {}
    }),
    methods: {
        fetchEntity() {
            this.$http.get(`${process.env.VUE_APP_API}/admin/entities/${this.$route.params.id}`, {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                this.entity = data.body.data;
            })
            .catch(error => {
                console.log(error.error);
            });
        }
    }
}
</script>

<style>

</style>